import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Mapper } from '@core/services/mapper/base-mapper.mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { ApiConstant } from '@shared/constants/api.constant';
import { UserType } from "@shared-features/enums/user-type.enum";
import { Role } from '@features/auth/models/role';

@Injectable({
  providedIn: 'root',
})
export class RolesApiService {
  constructor(private baseAPI: ApiBaseService, private mapper: Mapper) {}

  getActiveRoles(userType: UserType, extraUserTypes: UserType[] = []): Observable<Role[]> {
    const extraParams = extraUserTypes.map((t) => `&userType=${t}`).join('');
    return this.baseAPI.get(`${ApiConstant.GET_ACTIVE_ROLES}?userType=${userType}${extraParams}`).pipe(
      map((res) => {
        return this.mapper.fromJson(Role, res.data);
      })
    );
  }
}
